module.exports = __webpack_public_path__ + "static/media/cancelledLeave.54cd3dc0.svg";